import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    DialogTitle,
    FormControl,
    Grid, InputLabel, Select, Tab,
    TextField,
    Typography
} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {AccountsListService} from "../ListOfAccounts/AccountsListService";
import {useEffect, useLayoutEffect, useState} from "react";
import moment from "jalali-moment";
import {
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import GuardianAccount from "./GuardianAccount";
import CustomBackButton from "../customButton/CustomBackButton";
import MoreActionButton from "../customButton/MoreActionButton";
import UserStatus from "../../assets/images/AccountDetails/UserStatus.svg"
import LatePayment from "../../assets/images/AccountDetails/LatePayment.svg"
import FailureToPay from "../../assets/images/AccountDetails/FailureToPay.svg"
import DelayedInstallments from "../../assets/images/AccountDetails/DelayedInstallments.svg"
import UnpaidInstallments from "../../assets/images/AccountDetails/UnpaidInstallments.svg"
import DefaultDialogPage, {DialogSize} from "../defaultDialogPage/DefaultDialogPage";
import DeleteConfirmDialog from "../deleteConfirmDialog/DeleteConfirmDialog";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {Alert, AlertTitle, TabContext, TabList, TabPanel} from "@material-ui/lab";
import {css} from "@emotion/css";
import ReportItems, {ReportsItemTypes} from "../reportItem/ReportItems";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import ErrorPage, {ErrorType} from "../../pages/ErrorPage/ErrorPage";
import CustomTable from "../customTable/CustomTable";
import AccountTransactions from "./AccountTransactions";
import {convertUniversalDateToPersianDate} from "../../utils/TimeConvertor";
import MonthlyDeposits from "./monthlyDeposits/MonthlyDeposits";

const AccountDetails = ({openDialog, handleClose, needRefresh, selectedId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new AccountsListService(fundID, token, snackbar, loading)

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const [dateOfLatestInstallmentPaid, setDateOfLatestInstallmentPaid] = useState("");
    const [dateOfLatestLoan, setDateOfLatestLoan] = useState("");
    const [numberOfMonthsOfWaiting, setNumberOfMonthsOfWaiting] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [cashCode, setCashCode] = useState("");
    const [balance, setBalance] = useState("");
    const [userId, setUserId] = useState(-1);

    const [guardianName, setGuardianName] = useState("ندارد");
    const [guardianId, setGuardianId] = useState(null);
    const [openAt, setOpenAt] = useState("");

    const [cleared, setCleared] = useState(false);
    const [enabled, setEnabled] = useState(true);

    const [guardianInfo, setGuardianInfo] = useState(null)
    //state
    const [openModal, setOpenModal] = useState(false)

    const [numberOfLatePayments, setNumberOfLatePayments] = useState("");
    const [numberOfNonPayments, setNumberOfNonPayments] = useState("");
    const [numberOfInstallmentArrears, setNumberOfInstallmentArrears] = useState("");
    const [numberOfUnpaidInstallments, setNumberOfUnpaidInstallments] = useState("");
    const [status, setStatus] = useState("نا مشخص");

    const [selectedTab, setSelectedTab] = useState(tabTypes.INFO);

    const handleClickOpenModal = () => {
        setGuardianInfo(null)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
    }
    useEffect(() => {

        if (guardianInfo !== null) {
            if (guardianInfo.id !== userId) {
                setGuardianId(guardianInfo.id)
                setGuardianName(guardianInfo.name)
            } else
                snackbar(
                    setSnackbarDispatch(
                        SnackbarActionTypes.SHOW_WARNING,
                        "صاحب حساب نمی تواند قیم حساب خود باشد"
                    ))
        }
    }, [guardianInfo])


    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Filler,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    const [data, setData] = useState({datasets: []});

    const [loanKinds, setLoanKinds] = useState([]);

    //state

    useLayoutEffect(() => {
        if (selectedId > -1) {
            clearFields()
            getDataFromServer()
        }
    }, [selectedId])

    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getCashAccountInfo(fundID, selectedId)
            .then(({accountStatus, accountDetail}) => {
                setFirstName(accountDetail.ownerFirstName)
                setLastName(accountDetail.ownerLastName)
                setCashCode(accountDetail.number)
                setGuardianName(accountDetail.guardianFirstName ?
                    accountDetail.guardianFirstName + " " + accountDetail.guardianLastName :
                    "ندارد")
                setGuardianId(accountDetail.guardianId)
                setBalance(accountDetail.balance)
                setOpenAt(accountDetail.openedAt ? moment(accountDetail.openedAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")


                setEnabled(accountDetail.enabled)
                setCleared(accountDetail.cleared)

                setUserId(accountDetail.ownerId)

                if (accountStatus) {
                    setNumberOfLatePayments(accountStatus.numberOfLatePayments)
                    setNumberOfNonPayments(accountStatus.numberOfNonPayments)
                    setNumberOfInstallmentArrears(accountStatus.numberOfInstallmentArrears)
                    setNumberOfUnpaidInstallments(accountStatus.numberOfUnpaidInstallments)
                    setStatus(accountStatus.status)

                    setDateOfLatestLoan(accountStatus.dateOfLatestLoan ? convertUniversalDateToPersianDate(accountStatus.dateOfLatestLoan) : "-")
                    setDateOfLatestInstallmentPaid(accountStatus.dateOfLatestInstallmentPaid ? convertUniversalDateToPersianDate(accountStatus.dateOfLatestInstallmentPaid) : "-")
                    setNumberOfMonthsOfWaiting(accountStatus.numberOfMonthsOfWaiting)
                }

                loading(setLoadingStateDispatch(false))

            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت جزئیات حساب", snackbar, loading)

        })

    }

    function clearFields() {
        setFirstName("")
        setLastName("")
        setCashCode("")
        setBalance("")
        setGuardianName("")
        setOpenAt("")
        setCleared(false)
        setEnabled(true)

        setNumberOfLatePayments("")
        setNumberOfNonPayments("")
        setNumberOfInstallmentArrears("")
        setNumberOfUnpaidInstallments("")
        setStatus("نا مشخص")
        setSelectedTab(tabTypes.INFO)
        setData([])

        setNumberOfMonthsOfWaiting("")
        setDateOfLatestInstallmentPaid("")
        setDateOfLatestLoan("")
    }


    function doOnChange() {
        if (checkFieldsCondition()) {
            needRefresh(true)
            service.updateAccountInfo(
                fundID,
                selectedId,
                {
                    "enabled": enabled,
                    "number": cashCode,
                    "openedAt": moment.from(openAt, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD'),
                    "guardianId": guardianId
                }
            )
        }
    }

    function checkFieldsCondition() {
        let state = true
        let message = ""

        if (openAt.length !== 10) {
            message = "لطفا تاریخ ایجاد حساب را به درستی وارد نمایید!"
            state = false
        }

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }

    function deleteGuardian() {
        setGuardianId(null)
        setGuardianName("ندارد")
        setGuardianInfo(null)

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, "قیم حساب حذف شد، برای ثبت نهایی بر روی بروزرسانی کلیک نمایید."))
    }


    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    function handleOpenDeleteDialog() {

        setOpenDeleteDialog(true)
    }

    function handleCloseDeleteDialog() {
        setOpenDeleteDialog(false)
    }

    const [deleteConfirm, setDeleteConfirm] = useState("");

    function doDeleteItem() {
        if (deleteConfirm === "delete") {

            loading(setLoadingStateDispatch(true))
            service.clearAccount(fundID, selectedId)
                .then(response => {
                    handleCloseDeleteDialog()
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "حساب با موفقیت تسویه شد."))
                    getDataFromServer()
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در تسویه ی حساب!", snackbar, loading)
            })
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا کلمه delete را به درستی وارد نمایید"))
        }
    }


    function handleTabChange(event, newValue) {
        setSelectedTab(newValue);
    }

    useEffect(() => {
        if (selectedTab === tabTypes.LOAN_INFO) {
            loading(setLoadingStateDispatch(true))

            setData({datasets: []})
            setLoanKinds([])


            service.getLoanInfo(selectedId)
                .then(response => {


                    const label = []
                    const amount = []
                    for (let i = 1; i <= 100; i++) {
                        label.push(i)
                        amount.push(response.responseLoanOffers.item[i])
                    }

                    setLoanFileKey(response.responseLoanOffers.fileKey)
                    setLoanNumber(response.responseLoanOffers.number)

                    setData({
                        labels: label,
                        datasets: [
                            {
                                fill: true,
                                label: 'وام',
                                data: amount,
                                borderColor: 'rgb(53, 162, 235)',
                                backgroundColor: 'rgba(53, 162, 235, 0.5)',
                            },
                        ],
                    })

                    response.responseLoanKind.map((item, index) => {
                        setLoanKinds(prevState => [...prevState, {
                            number: index + 1,
                            id: item.id,
                            name: item.name,
                            codeName: item.codeName
                        }])
                    })
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت جزئیات حساب", snackbar, loading)
            })
        }
    }, [selectedTab])


    const [loanInstallment, setLoanInstallment] = useState("");
    const [loanAmount, setLoanAmount] = useState("");
    const [loanFileKey, setLoanFileKey] = useState("");
    const [loanNumber, setLoanNumber] = useState("");


    return (
        <>
            <DefaultDialogPage
                onClose={handleCloseDeleteDialog}
                open={openDeleteDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"تسویه حساب"}
            >
                <DeleteConfirmDialog
                    closeDialog={handleCloseDeleteDialog}
                    doDelete={doDeleteItem}
                    title={"آیا از تسویه حساب کاربر اطمینان دارید؟"}
                    description={"با اتمام فرایند، حساب تسویه شده و قابل بازگشت نخواهد بود!"}
                    submitTitle={"تسویه حساب"}
                />
            </DefaultDialogPage>

            {
                <GuardianAccount
                    openModal={openModal}
                    handleClickOpenModal={handleClickOpenModal}
                    handleCloseModal={handleCloseModal}
                    guardianInfo={setGuardianInfo}
                />
            }
            <Dialog onClose={handleClose}
                    fullScreen
                    aria-labelledby="customized-dialog-title"
                    id="customized-full-screen-dialog"
                    open={openDialog}>
                <DialogTitle id="customized-dialog-title">
                    <section className="d-flex flex-row flex-nowrap" style={{gap: "16px", padding: "0 1rem"}}>
                        <span className="flex-grow-1"> جزئیات حساب</span>

                        <MoreActionButton inVisibleState={cleared}>
                            <button className="btn-secondary" onClick={handleClickOpenModal}>
                                تغییر قیم حساب
                            </button>

                            <button className="btn-secondary" onClick={deleteGuardian}>
                                حذف قیم حساب
                            </button>

                        </MoreActionButton>

                        <CustomBackButton handleClose={handleClose}/>

                    </section>
                </DialogTitle>

                <section className={css`padding: 0 1rem 0 1rem`}>
                    <TabContext value={selectedTab}>
                        <TabList
                            onChange={handleTabChange} id="default-tab-container">
                            <Tab
                                label={"مشخصات"}
                                value={tabTypes.INFO}
                            />

                            <Tab
                                label={"گردش حساب"}
                                value={tabTypes.TRANSACTIONS}
                            />

                            <Tab
                                label={"واریز ماهانه"}
                                value={tabTypes.MONTHLY_DEPOSITS}
                            />

                            <Tab
                                label={"امتیاز وام"}
                                value={tabTypes.LOAN_INFO}
                            />

                            <Tab
                                label={"گزارشات"}
                                value={tabTypes.REPORTS}
                            />

                            <Tab
                                label={"بستن حساب"}
                                value={tabTypes.BLOCK_ACCOUNT}
                            />

                        </TabList>


                        <TabPanel value={tabTypes.INFO}>
                            <section className="flex-grow-1 flex-column">
                                <section className="ViewAccountDetailsContainer hideScrollBar hideScroll">
                                    <div className="accountDetailsContent">
                                        <div className="accountDetailsWrapper">
                                    <span className="fs-3 font_primary_bold">
                                        وضعیت کاربری
                                    </span>
                                            <p>{`${cleared ? "تسویه شده" : status} `}</p>
                                        </div>
                                        <img src={UserStatus} alt="userStatus"/>
                                    </div>
                                    <div className="accountDetailsContent">
                                        <div className="accountDetailsWrapper">
                                    <span className="fs-3 font_primary_bold">
                                        دیرکرد پرداخت
                                    </span>
                                            <p>{`${numberOfLatePayments ? numberOfLatePayments : "صفر "} ماه `}</p>
                                        </div>
                                        <img src={LatePayment} alt="latePayment"/>
                                    </div>
                                    <div className="accountDetailsContent">
                                        <div className="accountDetailsWrapper">
                                   <span className="fs-3 font_primary_bold">
                                        عدم پرداخت
                                   </span>
                                            <p>{`${numberOfNonPayments ? numberOfNonPayments : "صفر "} ماه `}</p>
                                        </div>
                                        <img src={FailureToPay} alt="failureToPay"/>
                                    </div>
                                    <div className="accountDetailsContent">
                                        <div className="accountDetailsWrapper">
                                    <span className="fs-3 font_primary_bold">
                                        اقساط تاخیر خورده
                                    </span>
                                            <p>{`${numberOfInstallmentArrears ? numberOfInstallmentArrears : "صفر "} ماه `}</p>
                                        </div>
                                        <img src={DelayedInstallments} alt="delayedInstallments"/>
                                    </div>
                                    <div className="accountDetailsContent">
                                        <div className="accountDetailsWrapper">
                                   <span className="fs-3 font_primary_bold">
                                        اقساط پرداخت نشده
                                   </span>
                                            <p>{`${numberOfUnpaidInstallments ? numberOfUnpaidInstallments : "صفر "} ماه `}</p>
                                        </div>
                                        <img src={UnpaidInstallments} alt="unpaidInstallments"/>
                                    </div>
                                </section>
                                <span>سابقه وام</span>
                                <Box className={`flex-grow-1 w-100 ${css`margin-bottom: .5rem;`}`} sm={12}>
                                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                                          style={{marginTop: '1rem'}}>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={dateOfLatestLoan} disabled="true" className='w-100'
                                                       variant="outlined"
                                                       label="آخرین وام دریافت شده"/>
                                        </Grid>

                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={dateOfLatestInstallmentPaid} disabled="true"
                                                       className='w-100'
                                                       variant="outlined"
                                                       label="آخرین قسط پرداخت شده"/>
                                        </Grid>

                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={numberOfMonthsOfWaiting} disabled="true" className='w-100'
                                                       variant="outlined"
                                                       label="ماه انتظار"/>
                                        </Grid>

                                    </Grid>
                                </Box>
                                <span>اطلاعات حساب</span>
                                <Box className="flex-grow-1 w-100" sm={12}>
                                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                                          style={{marginTop: '1rem'}}>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={firstName} disabled="true" className='w-100'
                                                       variant="outlined"
                                                       label="نام"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={lastName} disabled="true" className='w-100'
                                                       variant="outlined"
                                                       label="نام خانوادگی"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField
                                                disabled
                                                value={guardianName}
                                                className='w-100'
                                                variant="outlined" label="قیم حساب"/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={convertCurrencyFormatPositiveNegative(balance)}
                                                       disabled="true"
                                                       className={`w-100 ${css`direction: ltr;`}`}
                                                       variant="outlined"
                                                       label="موجودی حساب (ریال)"/>
                                        </Grid>
                                        {/*<Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={convertCurrencyFormatPositiveNegative(initialBalance)}
                                                       onChange={e => {
                                                           setInitialBalance((e.target.value).replaceAll(",", ""))
                                                       }}
                                                       disabled={cleared}
                                                       className='w-100'
                                                       variant="outlined"
                                                       label="موجودی اولیه حساب (ریال)"/>
                                        </Grid>*/}
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField value={cashCode} onChange={e => {
                                                setCashCode(e.target.value)
                                            }} className='w-100' variant="outlined"
                                                       label="شناسه حساب"
                                                       disabled={cleared}
                                            />
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <TextField
                                                value={convertToBirthDate(openAt)}
                                                onChange={e => {
                                                    setOpenAt(convertToBirthDate(e.target.value))
                                                }}
                                                className='w-100' variant="outlined"
                                                label="تاریخ ایجاد"
                                                disabled={cleared}/>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <FormControl variant="outlined" className="w-100">
                                                <InputLabel htmlFor="filled-age-native-simple">وضعیت حساب</InputLabel>
                                                <Select
                                                    disabled
                                                    label="وضعیت حساب"
                                                    value={cleared}
                                                    onChange={e => {
                                                        setCleared(e.target.value)
                                                    }}>
                                                    <option className="bg_active_state p-2" value={false}>فعال</option>
                                                    <option className="bg_deActive_state p-2" value={true}>بسته شده
                                                    </option>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid sm={6} md={4} lg={3} xl={4} className='p-2 w-100'>
                                            <label id='residenceStatus' className="toggle-switch-content">
                                                <span className="toggle-title">وضعیت</span>
                                                <label className="switch" htmlFor="MainCategory">
                                                    <input
                                                        type="checkbox"
                                                        id="residenceStatus"
                                                        checked={enabled}
                                                        disabled={cleared}
                                                        onChange={e => {
                                                            setEnabled(e.target.checked)
                                                        }}
                                                    />
                                                    <span className="toggle round"/>
                                                </label>

                                            </label>
                                        </Grid>
                                        <Grid sm={12} className={`p-2 w-100 ${css`width: 100%;
                                          display: flex;
                                          justify-content: end;`}`}>
                                            <button className={cleared ? "d-none" : "btn-confirm"} onClick={doOnChange}>
                                                بروزرسانی
                                            </button>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </section>
                        </TabPanel>

                        <TabPanel value={tabTypes.TRANSACTIONS}>
                            <AccountTransactions
                                userId={selectedId}
                            />
                        </TabPanel>

                        <TabPanel value={tabTypes.MONTHLY_DEPOSITS}>
                            <MonthlyDeposits id={selectedId}/>
                        </TabPanel>

                        <TabPanel value={tabTypes.LOAN_INFO}>
                            <section className={css`
                              gap: 16px;
                              display: flex;
                              flex-direction: column;
                              padding-bottom: 1rem;
                            `}>
                                {
                                    data && data.datasets && data.datasets.length > 0 ?

                                        <Box sm={12}
                                             className={css`
                                               display: flex;
                                               flex-direction: column;
                                               gap: .5rem;`}>
                                            <Grid
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                                className={css`direction: ltr;
                                                  max-height: 50vh;
                                                  max-width: 100vw;
                                                  overflow-x: auto;
                                                  overflow-y: hidden;
                                                  margin-bottom: 1rem;
                                                `}>

                                                <Line className={css`max-height: 50vh`} options={options} data={data}
                                                      type={""}/>
                                            </Grid>
                                            <span className={css`
                                              width: 100%;
                                              text-align: center;
                                              font-size: 13px;
                                            `}>{`سطر ${loanNumber} از فایل ${loanFileKey}`}</span>

                                            <Grid sm={12} className={"py-3"}>
                                                محاسبه وام
                                            </Grid>

                                            <Grid sm={12} md={12} lg={12} xl={12} xs={12} className={"d-flex flex-row"}>
                                                <Grid sm={12} md={6} lg={6} xl={6} className={"p-2"}>
                                                    <TextField
                                                        value={loanInstallment}
                                                        onChange={e => {
                                                            const value = e.target.value
                                                            if (value <= 100 && value >= 0) {
                                                                setLoanInstallment(value)
                                                                try {
                                                                    const loanValue = data.datasets[0].data[value - 1]
                                                                    if (typeof loanValue !== 'undefined')
                                                                        setLoanAmount(loanValue)
                                                                    else
                                                                        setLoanAmount("")
                                                                } catch (e) {
                                                                    setLoanAmount("")
                                                                }
                                                            }
                                                        }}
                                                        inputMode={"numeric"}
                                                        type={"number"}
                                                        className='w-100' variant="outlined"
                                                        label="تعداد اقساط"/>
                                                </Grid>

                                                <Grid sm={12} md={6} lg={6} xl={6} className={"p-2"}>
                                                    <TextField
                                                        value={convertCurrencyFormatPositiveNegative(loanAmount)}
                                                        disabled={true}
                                                        className='w-100'
                                                        variant="outlined"
                                                        label="مبلغ وام"/>
                                                </Grid>
                                            </Grid>

                                            <Grid sm={12} className={"py-3"}>
                                                نوع وام های قابل دریافت
                                            </Grid>

                                            <Grid sm={12}>
                                                <CustomTable
                                                    title={"هیچ نوع وام آماده ای یافت نشد!"}
                                                    data={loanKinds}
                                                    header={[
                                                        {
                                                            id: 'number',
                                                            label: '#',
                                                            align: 'right',

                                                        }, {
                                                            id: 'name',
                                                            label: 'نام',
                                                            align: 'right',

                                                        }, {
                                                            id: 'codeName',
                                                            label: 'شناسه',
                                                            align: 'right',

                                                        },
                                                    ]}
                                                    rowClicked={_ => {

                                                    }}/>
                                            </Grid>
                                        </Box> :

                                        <ErrorPage
                                            errorType={ErrorType.NOT_FOUND}
                                            title={"امتیاز وام"}
                                            subTitle={"هیچ اطلاعاتی برای نمایش وجود ندارد"}
                                        />}

                            </section>
                        </TabPanel>

                        <TabPanel value={tabTypes.REPORTS}>
                            <section className={css`
                              margin-top: 1rem;
                              gap: 16px;
                              display: flex;
                              flex-direction: column;
                            `}>
                                <ReportItems
                                    title={"دریافت گزارش خلاصه وضعیت حساب"}
                                    downloadExcel={_ => {
                                        service.downloadDepositAccountReports(selectedId, ReportsItemTypes.XLSX)
                                    }}
                                    downloadPdf={_ => {
                                        service.downloadDepositAccountReports(selectedId, ReportsItemTypes.PDF)
                                    }}
                                />

                                <ReportItems
                                    title={"دریافت گزارش وام های حساب"}
                                    downloadExcel={_ => {
                                        service.downloadDepositAccountLoanReports(selectedId, ReportsItemTypes.XLSX)
                                    }}
                                    downloadPdf={_ => {
                                        service.downloadDepositAccountLoanReports(selectedId, ReportsItemTypes.PDF)
                                    }}
                                />

                            </section>
                        </TabPanel>

                        <TabPanel value={tabTypes.BLOCK_ACCOUNT}>
                            <section className={css`
                              margin-top: 1rem;
                              gap: 16px;
                              display: flex;
                              flex-direction: column;
                            `}>

                                <Alert severity="warning" className={`warning-alert`}>
                                    <AlertTitle>آیا از تسویه حساب کاربر اطمینان دارید؟</AlertTitle>
                                    <div className={css`display: flex;
                                      flex-direction: column;
                                      gap: 8px;
                                      margin-top: 16px;
                                    `}>
                                        <span>با اتمام فرایند، حساب تسویه شده و قابل بازگشت نخواهد بود!</span>
                                        <span>برای تایید حذف حساب لطفا کلمه <strong>delete</strong> را در کارد زیر وارد کرده و سپس تایید نمایید.</span>
                                    </div>
                                </Alert>
                                <Grid sm={12} md={12} lg={12} xl={12} className='w-100'>
                                    <TextField value={deleteConfirm}
                                               onChange={e => {
                                                   setDeleteConfirm(e.target.value)
                                               }}
                                               className='w-100'
                                               variant="outlined"
                                               placeholder={"delete"}
                                               label="تایید حذف حساب"/>
                                </Grid>
                                <div className={css`display: flex;
                                  flex-direction: row;
                                  justify-content: end; `}>
                                    <button onClick={doDeleteItem} className={"btn-confirm"}>تایید</button>
                                </div>
                            </section>
                        </TabPanel>

                    </TabContext>
                </section>
            </Dialog>
        </>

    )
};
export default AccountDetails;


const tabTypes = {
    INFO: "INFO",
    LOAN_INFO: "LOAN_INFO",
    TRANSACTIONS: "TRANSACTIONS",
    MONTHLY_DEPOSITS: "MONTHLY_DEPOSITS",
    REPORTS: "REPORTS",
    BLOCK_ACCOUNT: "BLOCK_ACCOUNT"
}


